export default "__VITE_ASSET__CRF8U4DJ__"